import {Component, OnInit, Input} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {StateCountry} from '../../shared/common-components/common-structure';
import {NameAndAddress} from './name-and-address';
import {NameAndAddressService} from '../../services/name-and-address/name-and-address.service';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';


@Component({
    selector: 'app-hhg-extra-pickupdelivery-address',
    templateUrl: './hhg-extra-pickupdelivery-address.component.html',
    styleUrls: ['./hhg-extra-pickupdelivery-address.component.css'],
    standalone: false
})
export class HhgExtraPickupdeliveryAddressComponent implements OnInit {

  hhgpickupDeliveryAddressForm: UntypedFormGroup;
  addressInfo: UntypedFormArray;
  countryList: StateCountry[] = null;
  validationMessages: any;
  formLength: any;
  nameAndAddress: NameAndAddress;
  del: any;
  addresses = [];
  allCountriesList: StateCountry[] = [];
  allStatesList: StateCountry[] = [];
  redirectedFromBol = false;
  @Input() public shipmentsId;
  shipId;

  pickupDeliveryType: string[] = [
    'Extra Pickup Delivery - At Origin',
    'Extra Pickup Delivery - At Destination',
    'Extra Pickup Delivery - In Route',
  ];
  newAddresses = [];

  constructor(private formBuilder: UntypedFormBuilder, private modalService: BsModalService,
              private nameAndAddressService: NameAndAddressService, private bsModalRef: BsModalRef, private alertService: AlertService,
              private stateCountryService: StateCountryService, private loader: LoadingService) {
    this.createPickupDeliveryAddressForm();
    this.getCountryList();
    this.getStateList();

    this.validationMessages = {
      'pickDelType': [
        {type: 'required', message: 'Pickup / Delivery type is required'}
      ],
      'addLine1': [
        {type: 'required', message: 'Address is required'}
      ],
      'city': [
        {type: 'required', message: 'City is required'}
      ],
      'state': [
        {type: 'required', message: 'State is required'}
      ],
      'zip': [
        {type: 'required', message: 'Zip is required'}
      ],
      'country': [
        {type: 'required', message: 'Country is required'}
      ],
      'email': [
        {type: 'email', message: 'Email is invalid'}
      ]
    };
  }

  ngOnInit() {
    this.shipId = this.shipmentsId;
    this.addresses = [];
    this.loadExistingAddresses();
    const aInfo = this.hhgpickupDeliveryAddressForm.get('addressInfo') as UntypedFormArray;
  }

  /**
   * @description Address Components to be added to Form Array
   */
  createAddressForm(): UntypedFormGroup {
    return this.formBuilder.group({
      pickDelType: ['', [Validators.required]],
      addLine1: ['', [Validators.required]],
      addLine2: ['', []],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zip: ['', [Validators.required]],
      country: ['UNITED STATES', [Validators.required]],
      primaryPhone: ['', [Validators.required]],
      alternatePhone: ['', []],
      email: ['', [Validators.email]],
      otherContactInfo: ['', []],
      isExisting: [false, []],
      arrIndex: [0, []]
    });
  }

  /**
   * @description Form creation
   */
  createPickupDeliveryAddressForm() {
    this.hhgpickupDeliveryAddressForm = this.formBuilder.group({
      addressInfo: this.formBuilder.array([this.createAddressForm()])
    });
  }

  /**
   * @ description get country
   */
  getCountryList() {
    this.stateCountryService.getAllCountries().subscribe(
      allCountries => {
        this.allCountriesList = allCountries;
      },
      error => {
        this.alertService.error('Error while getting countries list');
      }
    );
  }

  getStateList() {
    this.stateCountryService.getAllStates().subscribe(
      allStates => {
        this.allStatesList = allStates;
        console.log(this.allStatesList);
      },
      error => {
        this.alertService.error('Error while getting states list');
      }
    );
  }

  getStateId(stateName) {
    for (let i = 0; i < this.allStatesList.length; i++) {
      if (this.allStatesList[i].stateCountryName == stateName) {
        return this.allStatesList[i].stateCountryId;
      }
    }
    return null;
  }

  getCountryId(countryName) {
    for (let i = 0; i < this.allCountriesList.length; i++) {
      if (this.allCountriesList[i].stateCountryName == countryName) {
        return this.allCountriesList[i].stateCountryId;
      }
    }
    return null;
  }

  getStateName(stateId) {
    for (let i = 0; i < this.allStatesList.length; i++) {
      if (this.allStatesList[i].stateCountryId == stateId) {
        return this.allStatesList[i].stateCountryName;
      }
    }
    return null;
  }

  getCountryName(countryId) {
    for (let i = 0; i < this.allCountriesList.length; i++) {
      if (this.allCountriesList[i].stateCountryId == countryId) {
        return this.allCountriesList[i].stateCountryName;
      }
    }
    return null;
  }

  /**
   * @description Save extra pickup delivery addresses
   */
  saveaddress() {
    const addressArray = this.hhgpickupDeliveryAddressForm.get('addressInfo') as UntypedFormArray;
    this.formLength = addressArray.length;
    for (let i = 0; i < (this.formLength); i++) {
      if (addressArray.controls[i].get('isExisting').value == true) {
        this.del = this.addresses[addressArray.controls[i].get('arrIndex').value];
        this.del.recordType = addressArray.controls[i].get('pickDelType').value;
        this.del.shipmentsId = this.shipmentsId;
        this.del.addressLine1 = addressArray.controls[i].get('addLine1').value;
        this.del.addressLine2 = addressArray.controls[i].get('addLine2').value;
        this.del.city = addressArray.controls[i].get('city').value;
        this.del.stateId = this.getStateId(addressArray.controls[i].get('state').value);
        this.del.zipCode = addressArray.controls[i].get('zip').value;
        this.del.countryId = this.getCountryId(addressArray.controls[i].get('country').value);
        this.del.phone = addressArray.controls[i].get('primaryPhone').value;
        this.del.alternatePhone = addressArray.controls[i].get('alternatePhone').value;
        this.del.otherContactInfo = addressArray.controls[i].get('otherContactInfo').value;
        this.del.emailAddress = addressArray.controls[i].get('email').value;
      } else {
        this.del = new NameAndAddress;
        this.del.recordType = addressArray.controls[i].get('pickDelType').value;
        this.del.shipmentsId = this.shipmentsId;
        this.del.addressLine1 = addressArray.controls[i].get('addLine1').value;
        this.del.addressLine2 = addressArray.controls[i].get('addLine2').value;
        this.del.city = addressArray.controls[i].get('city').value;
        this.del.stateId = this.getStateId(addressArray.controls[i].get('state').value);
        this.del.zipCode = addressArray.controls[i].get('zip').value;
        this.del.countryId = this.getCountryId(addressArray.controls[i].get('country').value);
        this.del.phone = addressArray.controls[i].get('primaryPhone').value;
        this.del.alternatePhone = addressArray.controls[i].get('alternatePhone').value;
        this.del.otherContactInfo = addressArray.controls[i].get('otherContactInfo').value;
        this.del.emailAddress = addressArray.controls[i].get('email').value;
      }

      this.newAddresses.push(this.del);
    }
    this.addresses = this.newAddresses;
    this.newAddresses = [];
    this.loader.show();
    this.nameAndAddressService.saveAddresses(this.addresses).subscribe(addArray => {
      this.loader.hide();
      this.addresses = addArray;
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Error while saving addresses');
    });

    this.bsModalRef.hide();
  }

  /**
   * @description Close modal
   */
  cancelAddress() {
    // TODO: close modal
    // ALso should the accessorial code be removed from the form?
    // this.bsModalRef.hide();
    this.bsModalRef.hide();
    const aInfo = this.hhgpickupDeliveryAddressForm.get('addressInfo') as UntypedFormArray;

  }

  /**
   * @description Dynamically add more pickup / delivery address
   */
  addMoreAddress() {
    this.addressInfo = this.hhgpickupDeliveryAddressForm.get('addressInfo') as UntypedFormArray;
    this.addressInfo.push(this.createAddressForm());
    const aInfo = this.hhgpickupDeliveryAddressForm.get('addressInfo') as UntypedFormArray;
  }

  loadExistingAddresses() {
    this.loader.show();
    this.nameAndAddressService.getShipmentAddressesForAccessorials(this.shipmentsId).subscribe(existingAddress => {
      this.addresses = existingAddress;
      for (let i = 0; i < existingAddress.length; i++) {
        this.displayExisting(existingAddress, i);
      }
      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Error while getting existing addresses');
    });
  }

  displayExisting(addrArray, index) {
    this.addressInfo = this.hhgpickupDeliveryAddressForm.get('addressInfo') as UntypedFormArray;
    if (index == 0) { // patch to remove blank array
      this.addressInfo.removeAt(0);
    }
    this.addressInfo.push(this.formBuilder.group({
      pickDelType: [addrArray[index].recordType, [Validators.required]],
      addLine1: [addrArray[index].addressLine1, [Validators.required]],
      addLine2: [addrArray[index].addressLine2, []],
      city: [addrArray[index].city, [Validators.required]],
      state: [this.getStateName(addrArray[index].stateId), [Validators.required]],
      zip: [addrArray[index].zipCode, [Validators.required]],
      country: [this.getCountryName(addrArray[index].countryId), [Validators.required]],
      primaryPhone: [addrArray[index].phone, [Validators.required]],
      alternatePhone: [addrArray[index].alternatePhone, []],
      email: [addrArray[index].emailAddress, [Validators.email]],
      otherContactInfo: [addrArray[index].email, []],
      isExisting: [true, []],
      arrIndex: [index, []]
    }));
  }

}


